import React from "react";
import _data from "../../data";

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      aboutUs: {}
    };
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
    this.setState({
      aboutUs: _data.aboutUs2
    });
  }

  render() {
    return (
      <React.Fragment>
        <section id="about" className="about-us ptb-100 gray-light-bg">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-6">
                <div className="about-content-left">
                  <p className="color-secondary">
                    <strong>About Us</strong>
                  </p>
                  <h2>{this.state.aboutUs.title}</h2>
                  <p>{this.state.aboutUs.description}</p>
                  
                    {(this.state.aboutUs.items || []).map((item, index) => {
                      return (
                        <div className="single-feature mb-4" key={index}>
                            <div className="d-flex align-items-center mb-2">
                                <span className={item.icon}></span>
                                <h5 className="mb-0">{item.title}</h5>
                            </div>
                            <p>{item.longDescription}</p>
                        </div>
                      );
                    })}
                  <a href="/#" className="btn solid-btn mt-2">View additional 20+ features</a>
                </div>
              </div>
              <div className="col-md-6">
                <div className="about-content-right">
                  <img
                    src="img/about-img.png"
                    alt="about us"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default About;
